import { useAuth } from '@clerk/clerk-react';
import { css } from '@emotion/react';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { Spinner } from './ui/spinner';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return (
      <div
        css={css`
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
        `}
      >
        <Spinner />
      </div>
    );
  }
  if (!isSignedIn) return <Navigate to="/sign-in" replace />;

  return <>{children}</>;
}
